import { createSelector } from 'reselect';
import { RootState } from 'store';
import { IntakeFormCustomQuestionCategory } from 'types/IntakeForm';
import { PetTypeId } from 'types/Pet';

export const getMarketplaceState = (state: RootState) => state.marketplace;

export const getMarketplace = createSelector(
    (state: RootState) => state.marketplace,
    marketplace => marketplace.data
);

export const getMarketplaceDeposit = createSelector(
    [getMarketplace],
    marketplace => marketplace.deposit
);

export const getPetSizes = createSelector(
    [
        (state: RootState) => state.marketplace.data.petTypes,
        (state: RootState, petType: PetTypeId) => petType
    ],
    (petTypes, petType) => petTypes[petType].sizes
);

export const getPetHairLengths = createSelector(
    [
        (state: RootState) => state.marketplace.data.petTypes,
        (state: RootState, petType: PetTypeId) => petType
    ],
    (petTypes, petType) => petTypes[petType].hairLengths
);

export const getOnlineBookingPreferences = createSelector(
    [getMarketplace],
    marketplace => marketplace.onlineBookingPreferences
);

export const getIntakeFormQuestions = createSelector([getMarketplace], marketplace =>
    marketplace.intakeFormPreferences.questionsEnabled
        ? marketplace.intakeFormPreferences.questions
        : undefined
);

export const getIntakeFormCustomerQuestions = createSelector([getMarketplace], marketplace =>
    marketplace.intakeFormPreferences.questions
        ? marketplace.intakeFormPreferences.questions.filter(
              question => question.category === IntakeFormCustomQuestionCategory.FOR_CUSTOMER
          )
        : undefined
);

export const getIntakeFormPetQuestions = createSelector([getMarketplace], marketplace =>
    marketplace.intakeFormPreferences.questions
        ? marketplace.intakeFormPreferences.questions.filter(
              question => question.category === IntakeFormCustomQuestionCategory.FOR_PET
          )
        : undefined
);
